import { IconProps } from "@tabler/icons-react";
import { ComponentType } from "react";

import { Button, mantineColorRamps, tokens, UnstyledButton } from "~/ui";

import { OrgAnchor } from "../OrgAnchor";
import styles from "./AccountActionsNavItem.module.css";
import { accountActionsNavItemHoverStyle } from "./account-actions-nav-item-style";

type HeaderActionsNavItemProps = {
  color?: keyof typeof mantineColorRamps;
  icon: ComponentType<IconProps>;
  label: string;
  url?: string;
  onClick?: () => void;
};

export const AccountActionsNavItem = (props: HeaderActionsNavItemProps): JSX.Element => {
  const themeColor = props.color ? mantineColorRamps[props.color] : mantineColorRamps.gray;

  return props.url ? (
    <UnstyledButton onClick={props.onClick} className={styles.navButton} style={accountActionsNavItemHoverStyle(themeColor[1])}>
      {/*
        Intended padding lives on `style` below. Do not add a Mantine `p` style prop: v7 writes
        that inline and it wins over this padding (v6 emitted `p` as a class, so `p={100}` was a
        no-op and the Profile row stayed compact).
      */}
      <OrgAnchor
        fw={600}
        href={props.url}
        iconLeft={props.icon}
        style={{
          color: themeColor[7],
          display: "block",
          maxWidth: "initial",
          padding: `${tokens.spacing.sm} ${tokens.spacing.md}`,
          width: "100%",
        }}
      >
        {props.label}
      </OrgAnchor>
    </UnstyledButton>
  ) : (
    <Button
      color={props.color ?? mantineColorRamps.gray[7]}
      size="xs"
      fullWidth
      leftIcon={<props.icon size={16} style={{ marginRight: 4 }} />}
      onClick={props.onClick}
      pt={tokens.spacing.sm}
      pb={tokens.spacing.sm}
      className={styles.navItemButton}
      variant="subtle"
    >
      {props.label}
    </Button>
  );
};
